import { FilterOperator } from "../../constants/filterOperators";

// TODO change this in other places to IFilterGroup
export type IFilter = IMfilesPropertyFilter | IOwnPropertyFilter;

export enum FilterGroupConditionEnum {
  AND = 'AND', // default
  OR  = 'OR',
}
export interface IFilterGroup {
  key?          : string;
  name?         : string;
  conditionType : FilterGroupConditionEnum;
  filters        : IFilter[];
  locked?       : boolean;
  ownerId?      : number;
}

export interface IMfilesPropertyFilter {
  name?: string; // remove??
  propertyId: number;
  operator: FilterOperator;
  value: string;
  locked?: boolean; // remove??
  ownerId?: number; // remove??
}

export interface IOwnPropertyFilter {
  name?: string; // remove?
  ownPropertyName: string;
  operator: FilterOperator;
  value: string;
  locked?: boolean; // remove?
  ownerId?: number; // remove?
}

export interface IQuickFilter {
  value: string;
}

export interface IValueListFilter {
  id: number;
  operator: FilterOperator;
  value: string;
}

export const isOwnPropertyFilter = (toBeDetermined: IMfilesPropertyFilter | IOwnPropertyFilter): boolean =>
  // eslint-disable-next-line no-prototype-builtins
  toBeDetermined?.hasOwnProperty("ownPropertyName");
